import { graphql } from "~/gql";

export const BEDROCK_START_STREAMING_MATTER_SUMMARY = graphql(/* GraphQL */ `
  mutation BedrockStartStreamingMatterSummary($input: GenerateSummaryInput!) {
    bedrockStartStreamingMatterSummary(input: $input) {
      sessionId
      success
    }
  }
`);

export const STREAMING_MATTER_SUMMARY_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription StreamingMatterSummary($sessionId: String!) {
    streamingMatterSummary(sessionId: $sessionId) {
      sessionId
      eventType
      chunk
      fullSummary
      error
    }
  }
`);
